import isDeepEqual from 'fast-deep-equal';
import { createWithEqualityFn } from 'zustand/traditional';
import type { AlertDialogProps } from '../ui/AlertDialog';

const initPageStore = Object.freeze({
  pageLoading: false as boolean,
  setPageLoading: (b: boolean) => {},
  headerVisible: true as boolean,
  footerVisible: true as boolean,
  dashboardTabsVisible: true as boolean,
  setDashboardTabsVisible: (b: boolean) => {},
  toggleAlertDialog: (props: AlertDialogProps) => {},
});

type PageStore = typeof initPageStore;

export const usePageStore = createWithEqualityFn<PageStore>(
  (set) => ({
    ...initPageStore,
    setPageLoading: (pageLoading: boolean) => set({ pageLoading }),
    setDashboardTabsVisible: (dashboardTabsVisible: boolean) => set({ dashboardTabsVisible }),
  }),
  (pastState, currentState) => isDeepEqual(pastState, currentState)
);
